import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import CentralMappingMappingEntry from 'lumen/models/central-mapping/mapping-entry';

export default class CentralMappingMappingEntryRoomType extends CentralMappingMappingEntry {
  // @ts-expect-error: Class inheritance
  [Type] = 'central-mapping/mapping-entry-room-type' as const;

  @attr('number') declare inventory: number | null;
  @attr('number') declare maxAdults: number | null;
}

// Type guard used for narrowing the type of a mapping entry to a room type mapping entry.
export const isMappingEntryRoomType = (
  mappingEntry: CentralMappingMappingEntry,
  // @ts-expect-error: A type predicate's type must be assignable to its parameter's type.
): mappingEntry is CentralMappingMappingEntryRoomType => {
  return 'inventory' in mappingEntry && 'maxAdults' in mappingEntry;
};
